import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel, type FilterField } from '@/components/common/AdvancedFilter';
import { areaManagersQueryOptions } from '@/features/users/api/users.api';
import { useOrgGeoFilterOptions } from '@/hooks/useOrgGeoFilterOptions';
import { getFilterPanelProps } from '@/hooks/useUrlSyncedFilters';
import {
  getActiveStatusFilterField,
  getCompanyDepartmentFilterFields,
  getDateFromToFilterFields,
  getGeoFilterFields,
  getReportingMemberFilterField,
} from '@/utils/filterFields';
import { ZM_STATUS_FILTER_KEY } from '../constants/dashboard.constants';
import type { useDcrDashboardFilters } from '../hooks/useDcrDashboardFilters';

interface DcrDashboardFilterPanelProps {
  controller: ReturnType<typeof useDcrDashboardFilters>;
}

export function DcrDashboardFilterPanel({ controller }: DcrDashboardFilterPanelProps) {
  const { filterValues } = controller;

  const { data: reportingMembers } = useQuery(areaManagersQueryOptions());
  const orgGeoOptions = useOrgGeoFilterOptions(filterValues);

  const fields: FilterField[] = [
    ...getDateFromToFilterFields(),
    getActiveStatusFilterField(ZM_STATUS_FILTER_KEY, {
      hasAllChoice: controller.hasAllStatusChoice,
    }),
    getReportingMemberFilterField(reportingMembers),
    ...getCompanyDepartmentFilterFields(orgGeoOptions),
    ...getGeoFilterFields(filterValues, orgGeoOptions),
  ];

  return <AdvancedFilterPanel fields={fields} {...getFilterPanelProps(controller)} />;
}
